import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useModules } from "@/lib/useModules";
import { AppTopBar } from "@/components/AppTopBar";

export default function OrderDetail() {
  const { id } = useParams();
  const { user } = useAuth();
  const { can: canModule, ready: modReady } = useModules();
  const [o, setO] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/orders/${id}`)
      .then(({ data }) => setO(data))
      .catch((err) => setError(formatApiErrorDetail(err.response?.data?.detail) || err.message));
  }, [id]);

  if (modReady && !canModule("ORDER_GINEE")) {
    return (
      <div className="app-shell">
        <AppTopBar active="orders" />
        <main className="content"><div className="alert-error" data-testid="access-denied">Akses ditolak.</div></main>
      </div>
    );
  }

  return (
    <div className="app-shell">
      <AppTopBar active="orders" />
      <main className="content">
        <Link to="/orders/list" className="back-link" data-testid="back-to-list">← Kembali ke daftar order</Link>
        {error && <div className="alert-error" data-testid="error-banner">{error}</div>}

        {o && (
          <>
            <section className="panel" data-testid="order-detail-panel">
              <div className="panel-head">
                <h2 className="panel-title">Order {o.source_order_id}</h2>
                <span className="status-pill on" data-testid="operational-status">{o.operational_status}</span>
              </div>
              <div className="meta-grid">
                <div><span className="meta-label">ID Pesanan</span><span className="mono">{o.source_order_id}</span></div>
                <div><span className="meta-label">Booking ID</span><span>{o.booking_id || "-"}</span></div>
                <div><span className="meta-label">Store</span><span>{o.store_name || "-"}{!o.store_resolved && <span className="tag-warn">UNRESOLVED</span>}</span></div>
                <div><span className="meta-label">Waktu Pembayaran</span><span>{o.payment_time || "-"}</span></div>
                <div><span className="meta-label">Kurir</span><span>{o.courier || "-"}</span></div>
                <div><span className="meta-label">AWB</span><span className="mono">{o.tracking_no || "-"}</span></div>
              </div>
              {o.cancellation_status !== "NONE" && (
                <div className="exception-box" data-testid="cancellation-source">
                  <strong>Sinyal Pembatalan (Source):</strong> {o.cancellation_status}
                  {o.cancellation_time && <div>Waktu: {o.cancellation_time}</div>}
                  {o.cancellation_reason && <div>Alasan: {o.cancellation_reason}</div>}
                  <div className="biz-sub">Catatan: sinyal source, order TIDAK di-void pada tahap ini.</div>
                </div>
              )}
            </section>

            <section className="panel" data-testid="order-items-panel">
              <h2 className="panel-title">Item ({o.items.length})</h2>
              <div className="table-scroll">
                <table className="data-table" data-testid="order-items-table">
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Qty</th>
                      <th>Harga Promosi (source)</th>
                      <th>Match</th>
                    </tr>
                  </thead>
                  <tbody>
                    {o.items.map((it) => (
                      <tr key={it.id} data-testid={`order-item-${it.marketplace_sku}`}>
                        <td className="mono">{it.marketplace_sku}</td>
                        <td>{it.qty}</td>
                        <td className="mono">{it.promotional_price_source ?? "-"}</td>
                        <td>
                          {it.sku_resolved
                            ? <span className="status-pill on">MATCHED</span>
                            : <span className="tag-warn" data-testid={`unknown-sku-${it.marketplace_sku}`}>UNKNOWN_SKU</span>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </>
        )}
      </main>
    </div>
  );
}
